import { render, staticRenderFns } from "./widgetListSelecter.vue?vue&type=template&id=9476df42&scoped=true"
import script from "./widgetListSelecter.vue?vue&type=script&lang=js"
export * from "./widgetListSelecter.vue?vue&type=script&lang=js"
import style0 from "./widgetListSelecter.vue?vue&type=style&index=0&id=9476df42&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9476df42",
  null
  
)

export default component.exports